/* NA LEIBERL – "Zweite Kassa bitte …" beim Warenkorb-Button (nur Produktseite)
   Klick auf "Ins Einkaufswagerl legen" (oder den Button in der Sticky-Leiste):
   ca. 1 Sekunde steht "Zweite Kassa bitte …" im Button, danach wird ganz normal hinzugefuegt.
   Text und Dauer unten bei TEXT / DAUER_MS aenderbar. */
(function () {
  var TEXT = 'Zweite Kassa bitte';
  var DAUER_MS = 1000;
  var SELECTOR = '.product__info-container .product-form__submit, .nl-sticky-atc__btn';
  var releasing = false; // waehrend des echten Klicks (inkl. Sticky -> Haupt-Button) nichts abfangen

  function show(b) {
    b.dataset.nlLabel = b.innerHTML;
    b.style.minWidth = b.offsetWidth + 'px';
    b.classList.add('nl-kassa-busy');
    b.setAttribute('aria-busy', 'true');
    b.innerHTML = '<span class="nl-kassa-text">' + TEXT + '</span>' +
      '<span class="nl-kassa-dots" aria-hidden="true"><i>.</i><i>.</i><i>.</i></span>';
  }
  function restore(b) {
    if (b.dataset.nlLabel) b.innerHTML = b.dataset.nlLabel;
    delete b.dataset.nlLabel;
    b.classList.remove('nl-kassa-busy');
    b.removeAttribute('aria-busy');
    b.style.minWidth = '';
  }

  // Capture-Phase auf window: laeuft vor dem Theme und vor Gelato
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest(SELECTOR);
    if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true') return;
    if (releasing) return;                               // echter Klick darf durch
    e.preventDefault();
    e.stopImmediatePropagation();
    if (b.classList.contains('nl-kassa-busy')) return;  // Doppelklick ignorieren
    show(b);
    setTimeout(function () {
      restore(b);
      releasing = true;
      try { b.click(); } finally { releasing = false; }
    }, DAUER_MS);
  }, true);

  // Zurueck-Button des Browsers: Button wieder normal anzeigen
  window.addEventListener('pageshow', function () {
    Array.prototype.forEach.call(document.querySelectorAll('.nl-kassa-busy'), restore);
  });
})();
